import StringUtils from "src/utils/stringUtils";
import CONSTANTS from "src/utils/constants";

export const FILTERING_OPERATORS_FOR_STRING = [":", "!:", "=", "!="];

export const JEWorksheetTableColumns = [
    "worksheetName",
    "status",
    "lastExecuted"
];

export const JEWorksheetTemplateTableColumns = [
    "templateName",
    "status",
    "linkedWorksheets"
];

export const JE_WORKSHEET_DASHBOARD_TABLE_COLUMN_NAMES: {
    [key: string]: string;
} = Object.freeze({
    WORKSHEET_NAME: "worksheetName",
    STATUS: "status",
    LAST_EXECUTED: "lastExecuted",
});

export const JE_WORKSHEET_TEMPLATE_DASHBOARD_TABLE_COLUMN_NAMES: {
    [key: string]: string;
} = Object.freeze({
    TEMPLATE_NAME: "templateName",
    STATUS: "status",
    LINKED_WORKSHEETS: "linkedWorksheets",
});

export const JE_WORKSHEET_DEFAULT_COLLECTION_PREFERENCES = {
    pageSize: 20,
    visibleContent: JEWorksheetTableColumns,
    wrapLines: true,
    stickyColumns: { first: 0, last: 0 }
};

export const JE_WORKSHEET_TEMPLATE_DEFAULT_COLLECTION_PREFERENCES = {
    pageSize: 20,
    visibleContent: JEWorksheetTemplateTableColumns,
    wrapLines: true,
    stickyColumns: { first: 0, last: 0 }
};

export const WORKSHEET_VISIBLE_CONTENT_OPTIONS = JEWorksheetTableColumns.map((column) => ({
    id: column,
    label: StringUtils.convertCamelCaseToTitleCase(column)
}));

export const WORKSHEET_TEMPLATE_VISIBLE_CONTENT_OPTIONS = JEWorksheetTemplateTableColumns.map((column) => ({
    id: column,
    label: StringUtils.convertCamelCaseToTitleCase(column)
}));

export const PAGE_SIZE_OPTIONS = [
    { value: 20, label: "20 Requests" },
    { value: 50, label: "50 Requests" },
    { value: 100, label: "100 Requests" },
];
